import { useQuery } from "@tanstack/react-query";

import { getDairyHerdSize, getDairyHerdSizeAdmin } from "services";

import { getEnvironment } from "utils";

import { DEFAULT_CACHE_TIME, FOOTPRINTING_DAIRY_HERD_SIZE } from "consts";

import { FootprintingDairyHerdSize } from "models";

export const useGetFootprintingDairyHerdSize = (primaryDataId: string, options?: { enabled?: boolean }) => {
  const isAdmin = getEnvironment().admin;

  return useQuery<FootprintingDairyHerdSize[]>({
    queryKey: [FOOTPRINTING_DAIRY_HERD_SIZE, primaryDataId, isAdmin],
    queryFn: () => (isAdmin ? getDairyHerdSizeAdmin(primaryDataId) : getDairyHerdSize(primaryDataId)),
    enabled: options?.enabled !== false && !!primaryDataId,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
